import React from 'react'

function UpvoteFilled({ size, color }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_23162_68470)">
        <path d="M7.5013 17.5H15.0013C15.693 17.5 16.2846 17.0833 16.5346 16.4833L19.0513 10.6083C19.1263 10.4167 19.168 10.2167 19.168 10V8.33333C19.168 7.41667 18.418 6.66667 17.5013 6.66667H12.243L13.0346 2.85833L13.0596 2.59167C13.0596 2.25 12.918 1.93333 12.693 1.70833L11.8096 0.833334L6.31797 6.325C6.01797 6.625 5.83463 7.04167 5.83463 7.5V15.8333C5.83463 16.75 6.58463 17.5 7.5013 17.5ZM4.16797 17.5V7.5H0.834635V17.5H4.16797Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_23162_68470">
          <rect width={size} height={size} fill="white" transform="matrix(-1 0 0 -1 20 20)" />
        </clipPath>
      </defs>
    </svg>

  )
}

export default UpvoteFilled